import axios from "axios";
import { ApiUrl, header } from "../utils/modules.js";

export const getReconciliation = ({ category, page, limit }) =>
  axios.get(ApiUrl + "scheduled-calls/reconciliation", { ...header(), params: { category, page, limit } });
